<template>
  <div class="booking-card-outer-container">
    <div
      id="individual"
      class="tdesk-container"
      data-testid="I'm booking for an individual"
      @click="setScope('individual')"
    >
      <div class="booking-card-inner-container">
        <i class="fas fa-user" />
        <p>
          I'm booking for an individual
        </p>
        <i class="fas fa-chevron-circle-right" />
      </div>
    </div>
    <div
      id="group"
      class="tdesk-container"
      data-testid="I'm booking for a group"
      @click="setScope('group')"
    >
      <div class="booking-card-inner-container">
        <i class="fas fa-users" />
        <p>
          I'm booking for a group
        </p>
        <i class="fas fa-chevron-circle-right" />
      </div>
    </div>
  </div>
</template>

<script>
  import fireGaEvent from './fire_ga_event';

  export default {
    methods: {
      setScope(type) {
        if (type === 'individual') {
          this.$emit('set-places-required', 1);
        }
        this.$emit('set-scope', type);
        fireGaEvent('ssbc_v2_step1_booking_type', {'booking_type': type});
        this.$emit('proceed');
      },
    },
  };
</script>
